export class StringMatcher {
    regex: string[];
    denyRegex: string[];
    value: string[];
    denyValue: string[];
    matcherFunction: string;
}
